/* eslint-disable  @typescript-eslint/no-explicit-any */
import React,{ useState, useMemo } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import MUIBoxTable from "../../../../common/components/mui-table/mui-box-table";
import Radio from '@mui/material/Radio';
import CloseIcon from "../../../../assets/icons/closeIcon.svg";
import LeadsStatus from "../../lead-qualification-leads-status";
import LeadQualificationMergeConfirmationPopups from "../lead-qualification-fuzzy-merge-confirmation-popups/lead-qualification-merge-confirmation-popups";
import { mergeExactLeadDetails } from "../../../../api/lead";
import "./lead-qualification-merge-leads-popups.scss";

const LeadQualificationMergeLeadsPopups= (props: any) => {
   const {
        setIsShowMergeLeadsPopups,
        isShowMergeLeadsPopups,
        data,
        fetchFullName,
        setSelectedLeadId,
        setLoading, 
        setAlertMessage, 
        setAlertType,  
        setAlertOpen,
        fetchLeads,
        selectCriteria
  } = props;
  const [primaryLead, setPrimaryLead] = useState<any>(null);
  const [isShowConfirmMergePopup, setIsShowConfirmMergePopup] =
    useState<boolean>(false);
    const handleConfirmMerge = async () => {
          setLoading(true);
          
        try {
            const response = await mergeExactLeadDetails({ 
              'leadIds': data?.map((lead: any)=> lead?.id)?.filter((lead: any)=>lead !==primaryLead), 
              'primaryLeadId': primaryLead, 
              matchingCriteria: 'Fuzzy', 
              criteriaParam: selectCriteria });
            if (response?.status === 200) {
                setAlertMessage(`Lead duplicates merged successfully`);
                setAlertType("success");
                setAlertOpen(true);
                setSelectedLeadId([]);
                setIsShowMergeLeadsPopups(false);
                fetchLeads();
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
            setAlertType("error");
            setAlertOpen(true);
            setIsShowMergeLeadsPopups(false);
        } finally {
            setLoading(false);
            setAlertOpen(true);
            setIsShowMergeLeadsPopups(false);
        }
    };

  const headers = [
    { key: "primary", label: "Primary", isSortable: false },
    { key: "leadName", label: "Lead Name", isSortable: false },
    { key: "email", label: "Email", isSortable: false },
    { key: "phone", label: "Phone Number", isSortable: false },
    { key: "leadSource", label: "Lead Source", isSortable: false },
    { key: "leadOwner", label: "Lead Owner", isSortable: false },
    { key: "leadStatus", label: "Lead Status", isSortable: false },];

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} `:""}${middleName ? `${middleName} `:""}${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.owner)
        setPrimaryLead( data[0]?.id);
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
        };
      });
    }
    return [];
  }, [data]);



  return (
    <>
      <Dialog
        open={isShowMergeLeadsPopups}
        // onClose={() =>   {setIsShowMergeLeadsPopups(false)
        //   setSelectedLeadId([]); setAlertOpen(false); setAlertMessage(""); setAlertType(""); setLoading(false); fetchLeads();
        // }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`lead-qualification-merge-leads-popups`}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="header-wrapper">
              <div>
                <div className="header-wrapper-title">{`Merge Leads (By ${selectCriteria === "primary_phone_number" ? "Phone Number" : "Email"})`}</div>
                <div className="header-wrapper-sub-title">
Select one lead as the primary. All other matching leads will be merged into this selected lead, combining their information into a single profile.
                </div>
              </div>
              <div className="header-wrapper-close-icon">
                <img
                  src={CloseIcon}
                  onClick={() =>   {setIsShowMergeLeadsPopups(false)
                    setSelectedLeadId([]); setAlertOpen(false); setAlertMessage(""); setAlertType(""); setLoading(false); fetchLeads();
                  }}
                />
              </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="lead-qualification-merge-leads-popups-table">
            <div
              className="lead-qualification-merge-leads-popups-table-section"
            >
              <MUIBoxTable
                columns={headers}
                data={formattedData?.map((item) => ({
                  key: item.id,
                  leadName: item.leadName,
                  email: item.email,
                  phone: item.phone,
                  leadSource: item.leadSource,
                  leadOwner: item.leadOwner,
                  primary: <Radio checked={primaryLead === item.id} onChange= {()=> setPrimaryLead(item.id)}/>,
                  leadStatus: <LeadsStatus status={item.leadStatus} />,
                }))}
                // noResultText={noResultText}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="lead-qualification-merge-leads-popups-table-action">
            <button onClick={() =>{
              setIsShowMergeLeadsPopups(false);
              setSelectedLeadId([]); setAlertOpen(false); setAlertMessage(""); setAlertType(""); setLoading(false); fetchLeads();}} className="cancel-btn">
              Cancel
            </button>
            <button onClick={()=>{setIsShowConfirmMergePopup(true)}} autoFocus className="action-btn">
              Merge Leads
            </button>
          </div>
        </DialogActions>
      </Dialog>
      {isShowConfirmMergePopup && (
          <LeadQualificationMergeConfirmationPopups
            setIsShowConfirmMergePopup={setIsShowConfirmMergePopup}
            isShowConfirmMergePopup={isShowConfirmMergePopup}
            handleConfirmMerge= {handleConfirmMerge}
          />
        )}
    </>
  );
}

export default LeadQualificationMergeLeadsPopups;
